import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { css } from "styled-components/macro"; //eslint-disable-line
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import usePageMeta from "blog/utils/usePageMeta.js";
import { SITE_URL, SITE_NAME } from "blog/config.js";

/**
 * Page de contact : un seul formulaire.
 * Les métadonnées (titre, description, canonical, JSON-LD) sont posées par usePageMeta.
 */

const CONTACT_META = {
  title: "Nous contacter",
  description:
    "Contactez IA Besançon : suggestion de sujet, correction, information sur l’intelligence artificielle, la tech ou l’innovation dans le bassin bisontin.",
  path: "/contact",
  jsonLd: {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "Nous contacter",
    url: `${SITE_URL}/contact`,
    inLanguage: "fr-FR",
    isPartOf: { "@id": `${SITE_URL}/#website` },
    publisher: { "@type": "Organization", name: SITE_NAME, url: SITE_URL },
  },
};

export default () => {
  usePageMeta(CONTACT_META);

  return (
    <AnimationRevealPage>
      {/* Seul titre de la page : il doit être un h1 pour la structure du document. */}
      <ContactUsForm headingAs="h1" />
    </AnimationRevealPage>
  );
};
